import React, { useState } from "react";
import CategorySection from "./CategorySection";
import FeaturedProducts from "./FeaturedProducts";

const CategoryFilter = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);

  return (
    <div>
      <CategorySection onCategorySelect={setSelectedCategory} />
      <FeaturedProducts selectedCategory={selectedCategory} />
    </div>
  );
};

export default CategoryFilter;
